import { render, staticRenderFns } from "./NoSearchResult.vue?vue&type=template&id=06d53d76&scoped=true&"
import script from "./NoSearchResult.vue?vue&type=script&lang=ts&"
export * from "./NoSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./NoSearchResult.vue?vue&type=style&index=0&id=06d53d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d53d76",
  null
  
)

export default component.exports